module.exports = __webpack_public_path__ + "static/media/30OIOS6.d7b73576.jpg";